import Typography from '@components/v2/ui/Typography/Typography';
import LangEnum from '../../../../lang/LangEnum';
import { useTranslation } from '../../../translation/TranslationContext';
import ForceUpdateBaseModal from './ForceUpdateBaseModal';

type OrderWasUpdatedModalProps = {
  isOpen: boolean;
  isFinishingOrder: boolean;
  onClose: () => void;
  handleConfirmFinishOrder: () => void;
};

const OrderWasUpdatedModal = ({
  isOpen,
  onClose,
  isFinishingOrder,
  handleConfirmFinishOrder,
}: OrderWasUpdatedModalProps) => {
  const { translate } = useTranslation();

  return (
    <ForceUpdateBaseModal
      isOpen={isOpen}
      onDeny={onClose}
      onClose={onClose}
      onAccept={handleConfirmFinishOrder}
      title={LangEnum.ORDER_WAS_UPDATED_MODAL_TITLE}
      denyLabel={isFinishingOrder ? LangEnum.GLOBAL_GO_BACK : undefined}
      acceptLabel={isFinishingOrder ? LangEnum.ORDER_ITEMS_FINISH_MESSAGE : undefined}
      content={
        <Typography variant="body1" color="text.secondary" sx={{ pb: isFinishingOrder ? 0 : 0.5 }}>
          {translate(LangEnum.ORDER_WAS_UPDATED_MODAL_DESCRIPTION)}
        </Typography>
      }
    />
  );
};

export default OrderWasUpdatedModal;
